import React, { useEffect, useState } from "react";
import { Button, Modal, Space, Select, Input } from "antd";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { sessionService } from "../../Utils/SessionService";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { CONSTANTS } from "../../../Environments/constants";
import "./CustomModal.scss";
const { TextArea } = Input;
const { Option } = Select;

export default function CustomModal({ title, isVisible, handleCancel, dropDownValues, ticketId, actionType, updateStatus }) {
  const [remarks, setRemarks] = useState();
  const [dropdownSelected, setDropdownSelected] = useState();
  const [isValidationError, setIsValidationError] = useState(false);
  const [fileList, setFileList] = useState([]);
  useEffect(() => {
    if (fileList.length > 0 && remarks) {
      setIsValidationError(false);
    }
  }, [fileList,remarks])

  const onHandleDropdownChange = (item) => {
    setDropdownSelected(item)
  }
  const handleChange = (e) => {
    if (e?.target?.value) {
      setIsValidationError(false);
    }
    setRemarks(e?.target?.value);
  };
  const onCancel = () => {
    handleCancel();
    setRemarks("");
    setDropdownSelected(null);
    setFileList([]);
    setIsValidationError(false);
    document.getElementById('myfile').value = [];
  }


  const fileUpload = () => {
    if (!fileList.length || !remarks) {
      setIsValidationError(true);
    } else {
      var bodyFormData = new FormData();
      bodyFormData.append(
        "action_type",
        actionType
      );
      bodyFormData.append(
        "complaint_id",
        ticketId
      );
      bodyFormData.append(
        "remarks",
        remarks
      );
      
      Array.from(fileList).forEach(file => {
        bodyFormData.append('files', file);
      });

      ServiceUtils.postRequest("close-complaint", bodyFormData).then(
        (_response) => {
          let decodedData;
          if (_response?.data) {
            decodedData = JSON.parse(atob(_response.data));
          }
          if (_response.status === 200) {
            if (decodedData?.status === "success") {
              onCancel();
              alertService.success(
                decodedData?.message || `Complaint resolved successfully`
              );

            } else {
              alertService.error(
                decodedData?.message || `Failed to resolve complaint`
              );
            }
          } else {
            alertService.error(
              _response?.data?.message ||
              _response?.message ||
              "Internal Server Error"
            );
          }
        }
      );
    }
  }

  const onSetFiles = (files) => {
    setFileList(files)
  }

  const onSubmit = () => {
    if (actionType === 'resolved') {
      fileUpload();
    }
    else if (actionType.includes("return_to")) {
      if (!remarks) {
        setIsValidationError(true);
      }else{
      updateStatus(actionType, remarks);
      onCancel();
      }
    }
    else {
      const userDetails = sessionService.getSession("cpcb-user");
      const payload = {
        type: title,
        org_type: userDetails?.role[0],
        complaint_id: ticketId,
        org_id: dropdownSelected,
        user_id: userDetails?.user_id,
        comments: remarks,
      }
      if (!remarks) {
        setIsValidationError(true);
      } else {
        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("asign-transfer", encodedPayload).then(
          (_response) => {
            let decodedData;
            if (_response?.data) {
              decodedData = JSON.parse(atob(_response.data));
            }
            if (_response.status === 200) {
              if (decodedData?.status === "failed") {
                alertService.error(
                  decodedData?.message || `Error`
                );
              } else {
                alertService.success(
                  decodedData?.message || `Action taken successfully`
                );
                onCancel();
                // handleCancel();
              }
            } else {
              alertService.error(
                decodedData?.data?.message ||
                decodedData?.message ||
                "Internal Server Error"
              );
            }
          }
        );
      }
    }
  }
  return (
    <div>
      <Modal
        title={title}
        visible={isVisible}
        onOk={onSubmit}
        onCancel={onCancel}
        okButtonProps={{ type: 'primary' }}
        cancelButtonProps={{ type: 'default' }}
        okText={title}
        cancelText="Cancel"
        width={400}
        centered={true}

      >
        <div className="modal-body">
          {actionType === "resolved" &&
            <>
              <p className="paragraph-remarks">Upload action taken report</p>
              <input type="file" id="myfile" name="files" multiple  onChange={(e) => onSetFiles(e.target.files)} />
              {isValidationError &&
                <div className="errorMessage">Please upload atleast one file to resolve complaint</div>
              }
            </>
          }
          {(actionType === "assign" || actionType === "transfer") &&
            <>
              <p className="paragraph first-paragraph">{title} to</p>
              <Select
                placeholder="Select"
                style={{
                  width: '100%',
                }}
                value={dropdownSelected}
                onChange={onHandleDropdownChange}
              >
                {
                  dropDownValues?.map?.((item) => {
                    return <Option value={item.value}>{item.label}</Option>
                  })
                }
              </Select>
            </>
          }
          {/* {actionType !== "resolved" && */}
            <>
              <p className="paragraph-remarks">Remarks</p>
              <div>
                <TextArea
                  className="text-area"
                  style={{
                    height: 80,
                  }}
                  onChange={handleChange}
                  value={remarks}
                />
              </div>
              {isValidationError &&
                <div className="errorMessage">{CONSTANTS.COMMENT_VALIDATION}</div>
              }
            </>
           {/* }  */}
        </div>
      </Modal>
    </div>
  );
}
